import script from "./ShippingCompany.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShippingCompany.vue?vue&type=script&lang=ts&setup=true"

import "./ShippingCompany.vue?vue&type=style&index=0&id=4f016500&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f016500"]])

export default __exports__